import { MultiDimensionBarDimension } from "../components/OperationsDashboard/components/ChartTypes/MultiDimensionBarChart";
import { colors } from "./colors";

export const sectionOrder = [
  "Operations",
  "Employee Dashboard",
  "Projects Dashboard",
  "Financial Overview",
  "O2C Flow",
  "Demand Request",
  "Sales Tracker",
  "General Lists",
];

export const employeeDashboardOrder = {
  "Employees Overview": 1,
  "Employee: Allocation and Bench Analysis": 2,
  "Employee: Benched v/s Hiring Summary": 3,
  "Employees Directory": 4,
};

export const financialExportTableHeaders = [
  { label: "Name", key: "name" },
  { label: "Generated On", key: "generated_on" },
  { label: "Type", key: "type" },
  { label: "Company", key: "company" },
  { label: "Source", key: "source" },
  { label: "From - To Date", key: "from_to_date" },
  { label: "Additional Parameters", key: "additional_parameters" },
  { label: "Link", key: "link" },
  { label: "Status", key: "status" },
];

export const DEFAULT_TITLE = "Access Restricted";
export const DEFAULT_MESSAGE =
  "Not a registered user in QB Databoard, redirecting to QBurst Apps.";
export const DEFAULT_CONFIRM_BUTTON_TEXT = "OK";

export const REVENUE_MARGIN_DASHBOARD_ID = 88;
export const REVENUE_COST_ANALYSIS_DASHBOARD_ID = 95;
export const UTILIZATION_DASHBOARD_ID = 96;
export const SALES_PIPELINE_HEALTH_DASHBOARD_ID = 97;
export const WIN_LOSS_ANALYSIS_DASHBOARD_ID = 100;
export const REVENUE_SERIES_NAME = "Revenue";
export const PROJECT_MARGIN_SERIES_NAME = "Project Margin";
export const PROJECT_ALLOCATED_COST_SERIES_NAME = "Project Allocated Cost";
export const DIRECT_GROSS_MARGIN_SERIES_NAME = "D-GM";
export const CLIENT_ALLOCATED_COST_SERIES_NAME = "Client Allocated Cost";
export const BENCH_COST_SERIES_NAME = "Bench Cost";
export const INTERNAL_PLUS_INVESTMENT_SERIES_NAME =
  "Internal + Investment Cost";
export const CUSTOMER_MARGIN_SERIES_NAME = "Customer Margin";
export const EBITDA_MARGIN_SERIES_NAME = "EBITDA Margin";
export const EMPTY_STATE_MESSAGE =
  "No revenue data available for the selected filters.";
export const EMPTY_PROJECT_MARGIN_STATE_MESSAGE =
  "No project margin data available for the selected filters.";
export const EMPTY_PROJECT_ALLOCATED_COST_STATE_MESSAGE =
  "No project allocated cost data available for the selected filters.";
export const EMPTY_DIRECT_GROSS_MARGIN_STATE_MESSAGE =
  "No D-GM data available for the selected filters.";
export const EMPTY_CLIENT_ALLOCATED_COST_STATE_MESSAGE =
  "No client allocated cost data available for the selected filters.";
export const EMPTY_BENCH_COST_STATE_MESSAGE =
  "No bench cost data available for the selected filters.";
export const EMPTY_INTERNAL_PLUS_INVESTMENT_STATE_MESSAGE =
  "No internal + investment cost data available for the selected filters.";
export const EMPTY_CUSTOMER_MARGIN_STATE_MESSAGE =
  "No customer margin data available for the selected filters.";
export const EMPTY_EBITDA_MARGIN_STATE_MESSAGE =
  "No EBITDA margin data available for the selected filters.";
export const EMPTY_ARC_NON_DEPLOYED_STATE_MESSAGE =
  "No average resource cost data (non-deployed) available for the selected filters.";
export const EMPTY_ARC_DEPLOYED_STATE_MESSAGE =
  "No average resource cost (deployed) data available for the selected filters.";
export const EMPTY_AVERAGE_BILL_RATE_STATE_MESSAGE =
  "No average billing rate data available for the selected filters.";
export const ONSITE_SERIES_NAME = "Onsite";
export const OFFSHORE_SERIES_NAME = "Offshore";
export const SM_COST_SERIES_NAME = "S&M Cost";
export const EMPTY_SM_COST_STATE_MESSAGE =
  "No S&M cost data available for the selected filters.";
export const EMPTY_GA_GROSS_MARGIN_STATE_MESSAGE =
  "No G&A cost data available for the selected filters.";
export const GA_GROSS_MARGIN_SERIES_NAME = "G&A Cost";
export const EMPTY_PIPELINE_BY_OPPORTUNITY_TYPE_MESSAGE =
  "No pipeline by opportunity type data available for the selected filters.";
export const EMPTY_PIPELINE_BY_LEAD_SOURCES_MESSAGE =
  "No lead source pipeline data available for the selected filters.";
export const EMPTY_PIPELINE_BY_PROJECT_TYPE_MESSAGE =
  "No pipeline by project type data available for the selected filters.";
export const PIPELINE_TIME_SERIES_CHART_TITLE = "Pipeline - Time Series Analysis";
export const EMPTY_PIPELINE_TIME_SERIES_MESSAGE =
  "No pipeline time series data available for the selected filters.";
export const EMPTY_PIPELINE_AGING_ANALYSIS_MESSAGE =
  "No pipeline aging analysis data available for the selected filters.";
export const NO_DATA_MESSAGE = "No data available for the selected filters.";
export const WIN_RATIO_SERIES_NAME = "Win Ratio";
export const EMPTY_WIN_RATIO_STATE_MESSAGE =
  "No win ratio data available for the selected filters.";

export const pipelineAgeingBuckets = [
  { key: "0_30", label: "0-30 days" },
  { key: "31_60", label: "31-60 days" },
  { key: "61_90", label: "61-90 days" },
  { key: "gt_90", label: ">90 days" },
] as const;

export const pipelineAgingTrendBucketLabels: Record<string, string> =
  Object.fromEntries(
    pipelineAgeingBuckets.map(({ key, label }) => [`age_${key}`, label]),
  );

export const UTILIZATION_CHART_OFFSHORE_TITLE = "Offshore Utilization Trends";
export const UTILIZATION_CHART_ONSITE_TITLE = "Onsite Utilization Trends";
export const EMPTY_UTILIZATION_STATE_MESSAGE =
  "No utilization trend data available for the selected filters.";

export const MONTH_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const UTILIZATION_DIMENSIONS: MultiDimensionBarDimension[] = [
  {
    key: "deployed",
    label: "Deployed Utilization",
    color: colors.slateGray,
  },
  {
    key: "client",
    label: "Client Allocated",
    color: colors.mistGray,
  },
  {
    key: "billed",
    label: "Billed Utilization",
    color: colors.skyBlue,
  },
];

export const PIPELINE_TIME_SERIES_DIMENSIONS: MultiDimensionBarDimension[] = [
  {
    key: "wt_pipeline",
    label: "Wt.Pipeline",
    color: colors.chart_blue,
  },
  {
    key: "new_pipeline",
    label: "New Pipeline Added",
    color: colors.bar_gray,
  },
];
